import React from 'react';
import { Section, VideoPlayer } from './ui';
export const Product = () => {
  return <Section className="bg-white" data-id="element-150">
      <div className="text-center mb-10" data-id="element-151">
        <p className="text-xs sm:text-sm font-bold tracking-widest text-gray-500 uppercase mb-3" data-id="element-152">
          ESTO NO ES OTRO RECETARIO
        </p>
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-semibold mb-2 leading-tight" data-id="element-153">
          Por eso creé:
        </h2>
        <h3 className="text-4xl sm:text-5xl md:text-6xl font-serif font-semibold bg-gradient-to-r from-pink-500 to-orange-400 bg-clip-text text-transparent pb-2 leading-tight" data-id="element-154">
          “Pasteles Sin Culpa”
        </h3>
      </div>

      <div className="relative max-w-lg mx-auto mb-10 md:mb-12 px-2" data-id="element-155">
        <img src="https://images.unsplash.com/photo-1578985545062-69928b1d9587?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Pasteles Sin Culpa E-book" className="w-full rounded-2xl shadow-2xl" data-id="element-156" />
        <div className="absolute top-2 right-2 md:-top-4 md:-right-4 bg-brand-violet text-white font-bold py-2 px-3 md:py-3 md:px-6 rounded-full shadow-lg transform rotate-6" data-id="element-157">
          <p className="text-[10px] md:text-sm leading-tight" data-id="element-158">
            E-Book Completo
          </p>
          <p className="text-xs md:text-lg leading-tight" data-id="element-159">
            48 Recetas Maestras
          </p>
        </div>
      </div>

      <div className="bg-white border border-gray-100 rounded-3xl p-6 md:p-10 shadow-soft max-w-3xl mx-auto mb-12" data-id="element-160">
        <p className="text-base sm:text-lg md:text-xl text-center mb-6 md:mb-8 font-medium leading-relaxed" data-id="element-161">
          Un sistema paso a paso que te enseña cómo aplicar el Método de
          Estructura Húmeda™ en 48 recetas maestras:
        </p>

        <div className="flex flex-col sm:flex-row sm:flex-wrap justify-center items-center gap-3 sm:gap-6 md:gap-10 text-base md:text-lg font-medium mb-7 md:mb-8" data-id="element-162">
          <div className="flex items-center gap-3" data-id="element-163">
            <span className="text-brand-green text-2xl" data-id="element-164">✅</span> Sin gluten
          </div>
          <div className="flex items-center gap-3" data-id="element-165">
            <span className="text-brand-green text-2xl" data-id="element-166">✅</span> Sin lácteos
          </div>
          <div className="flex items-center gap-3" data-id="element-167">
            <span className="text-brand-green text-2xl" data-id="element-168">✅</span> Sin azúcar
            refinada
          </div>
        </div>

        <div className="bg-green-50 rounded-xl p-5 md:p-6 text-center border border-green-100" data-id="element-169">
          <p className="text-base sm:text-lg md:text-xl font-bold text-green-800 leading-snug" data-id="element-170">
            👉 Funcionan incluso si nunca has horneado antes.
          </p>
        </div>
      </div>

      <VideoPlayer src="https://i.imgur.com/hNg0vi3.mp4" data-id="element-171" />
    </Section>;
};